import apiClient from '../apiClient';
import { GET_RESTAURANT_LIST_URL } from '../apiUrl';

const getRestaurantListApi = () => {
  return apiClient.get(GET_RESTAURANT_LIST_URL);
};

export default getRestaurantListApi;
